import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';
import { siteMap } from '../constants/routes';
import { useRouteParams } from '../hooks/useRoutes';
import { useAutologinIBV } from '../hooks/useAutologinIBV';

/**
 * Public route
 * @param {Boolean} isAuthenticated
 * @returns
 */
const PublicRoute = ({ isAuthenticated }) => {
  useRouteParams()
  const { slim, isLoginIbv } =  useAutologinIBV()
  const destination = isLoginIbv ? <Navigate to={slim} /> : <Navigate to={siteMap.homepage.path} />

  return (isAuthenticated && !isLoginIbv) ? destination : <Outlet />;
};

PublicRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired
};

export default PublicRoute;